<template>
<div class="content">

    <toolbar v-bind:selection="toolbar" title="Tareas" />


    <v-tabs>
        <v-tabs-slider color="orange"></v-tabs-slider>

        <v-tab @click="tabs.tab1 = true; tabs.tab2 = false;">Abiertas ({{result.length}})</v-tab>
        <v-tab @click="tabs.tab1 = false; tabs.tab2 = true;">Completas ({{completed.length}})</v-tab>
    </v-tabs>



    <div v-if="tabs.tab1===true">
        <ul v-if="result.length>0"  id="completadas">
                <li v-for="task in result" :key="task.id" class="card" v-bind:id="'task'+task.id">
                    <div class="info-item">
                        <div class="info-item-list-left">

                            <a v-bind:href="'#/tarea-editar/' + task.id">


                                <span v-if="task.priority==='alta' || task.priority==='urgente'" class="badge badge-rojo">{{ task.priority }}</span>
                                <span v-if="task.priority==='normal'" class="badge badge-amarillo">{{ task.priority }}</span>
                                <span v-if="task.priority==='baja'" class="badge badge-verde">{{ task.priority }}</span>

                                <p>{{ task.date_created }}</p>

                                <p class="title-box">{{ task.description }}</p>

                                <p>Posición {{ task.position }} en Colmenar {{ task.namecolmenar }}</p>

                            </a>
                        </div>

                        <div class="info-item-list-right">

                            <a v-bind:href="'#/tarea-editar/' + task.id">
                                <v-icon color="grey">mdi-chevron-right</v-icon>
                            </a>
                        </div>
                    </div>
                </li>
        </ul>

        <div v-else class="card">
            <div style="padding:20px; text-align:center">
                No hay tareas dadas de alta.
            </div>
            <router-link to="../tarea-nueva" class="btn btn-yellow">
                Añadir tarea
            </router-link>
        </div>

    </div>

    <div v-if="tabs.tab2===true">

        <ul v-if="completed.length>0" id="completed">
            <li v-for="task in completed" :key="task.id" class="card" v-bind:id="'task'+task.id">
                <div class="info-item">
                    <div class="info-item-list-left">

                        <a v-bind:href="'#/tarea-editar/' + task.id">
                            <p>Fecha creación: {{ task.date_created }}</p>
                            <p>Fecha cierre: {{ task.date_completed }}</p>

                            <p class="title-box">{{ task.description }}</p>

                            <p>Posición {{ task.position }} en Colmenar {{ task.namecolmenar }}</p>

                        </a>
                    </div>

                    <div class="info-item-list-right">

                        <a v-bind:href="'#/tarea-editar/' + task.id">
                            <v-icon color="grey">mdi-chevron-right</v-icon>
                        </a>
                    </div>
                </div>
            </li>
        </ul>

        <div v-else class="card">
            <div style="padding:20px; text-align:center">
                No hay tareas completadas.
            </div>
        </div>

    </div>

    <menubottom active="3" />

</div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import menubottom from "@/components/MenuBottom"
import axios from "axios";

export default {
    name: 'tareas',
    components: {menubottom,toolbar},
    data() {
        return {
            tabs: {
                tab1: true,
                tab2: false,
            },
            toolbar: {
                return: '',
                icons: [
                  { text: 'Añadir tarea', href:'tarea-nueva/' },
                  { text: 'Cancelar', href:'tareas' }
                ],
              },
            result: null,
            completed:null,
        }
    },

    created() {
    auth.getUserLogged()
        var that = this
        axios.get("https://appws.panimiel.com/new/index.php/api/task/0").then((result) => {
          that.result = result.data
        })

        axios.get("https://appws.panimiel.com/new/index.php/api/task/1").then((completed) => {
          that.completed = completed.data
        })
    }

};

</script>

<style scoped lang="scss">
</style>